export function formatThousands(number) {
  if (number >= 1000000) {
    let result = (number / 1000).toFixed(2);
    result = result.replace(/\.00$/, "").replace(/\.0$/, "");
    return result.toLocaleString() + "K";
  } else {
    let result = isNaN(Number(number)) ? "" : Number(number).toFixed(2);
    result = result.replace(/\.00$/, "").replace(/\.0$/, "");
    return result.toLocaleString();
  }
}

export function addTotalColumnGeneric(
  data,
  excludeValues = [],
  totalKey = "total",
  excludeKeys = ["key", "type", "value"]
) {
  return data.map((row) => {
    if (excludeValues.includes(row.value)) {
      return { ...row, [totalKey]: "--" };
    }

    const total = Object.entries(row)
      .filter(([key, val]) => !excludeKeys.includes(key))
      .reduce((sum, [, val]) => {
        const num = parseFloat(val);
        return !isNaN(num) ? sum + num : sum;
      }, 0);

    return { ...row, [totalKey]: formatThousands(total) };
  });
}

function getColumnName(
  item,
  tableData,
  isQuarterlyData,
  isMonthlyData,
  isYearlyData
) {
  if (isQuarterlyData) {
    return tableData.quarters[item.quarter - 1];
  }

  if (isMonthlyData) {
    return tableData.months[item.month - 1];
  }

  if (isYearlyData) {
    return "yearly";
  }

  return null;
}

export function transformData(data, tableData) {
  const keyToRow = {};
  const updatedData = [];
  const isQuarterlyData = data.length === 4;
  const isMonthlyData = data.length === 12;
  const isYearlyData = data.length === 1;

  Object.keys(data[0]).forEach((key, index) => {
    if (!["month", "quarter", "year"].includes(key)) {
      updatedData.push({
        key: (index + 1).toString(),
        type: tableData.mapper[key],
        value: key,
      });
      keyToRow[key] = updatedData.length - 1;
    }
  });

  data.forEach((item) => {
    const columnName = getColumnName(
      item,
      tableData,
      isQuarterlyData,
      isMonthlyData,
      isYearlyData
    );

    Object.entries(item).forEach(([key, value]) => {
      if (!["month", "quarter", "year"].includes(key)) {
        const rowIndex = keyToRow[key];

        const isQuarterly = key.includes("quaterly") && item.month % 3 !== 0;
        const isYearly = key.includes("yearly") && item.month % 12 !== 0;

        if (isQuarterly || isYearly) {
          updatedData[rowIndex][columnName] = "-";
        } else {
          updatedData[rowIndex][columnName] =
            value === null ? 0 : formatThousands(value);
        }
      }
    });
  });

  return updatedData;
}

export const convertAdjustmentObjectToArray = (
  adjustmentObject,
  adjustmentKeyName,
  months
) => {
  return Object.keys(adjustmentObject)
    .filter((month) => adjustmentObject[month] !== undefined)
    .map((month) => ({
      month: months.indexOf(month) + 1,
      [adjustmentKeyName]: parseInt(adjustmentObject[month]),
    }));
};
